import { inject, Injectable } from "@angular/core";

import { PageStateLocalStorageService } from "../local-storage-services/page-state-local-storage.service";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable({
    providedIn: 'root'
})
export class HeaderStorageService
{
    private readonly __pageStateLocalStorageService = injectRequired(PageStateLocalStorageService);

    headerData$$ = this.__pageStateLocalStorageService.headerData$$;
}